import { numericUtil } from '@cmg/common';
import { createValueFormatter } from '@cmg/data-grid';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';
import type { Value } from './AllocationSharesCellRenderer';
import { AllocationSharesCellRenderer } from './AllocationSharesCellRenderer';

export { Value };

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => numericUtil.getDisplayValueForInteger(value),
});

const allocationSharesColDef: CalendarGridColDef<Value> = {
  colId: 'allocationShares',
  field: 'lastAllocation.shares',
  headerName: 'Allocation (Shares)',
  width: 141,
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  valueFormatter,
  cellRenderer: AllocationSharesCellRenderer,
};

export default allocationSharesColDef;
